import PropTypes from 'prop-types'

import {BASE_CLASS} from '../config.js'

export function Description({children}) {
  return <p className={`${BASE_CLASS}-description`}>{children}</p>
}

Description.propTypes = {
  children: PropTypes.node.isRequired
}
